
export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.chart   = json.chart
      this.tube    = json.tube
      this.base    = json.base
      this.title   = json.title
      this.columns = json.columns
      this.keys    = json.keys
      this.filters = json.filters
      this.sundries  = json.sundries

     
    },
    
      
  }
}